import RuleDetailPage from "./RuleDetailPage";
import { useAppRouteState } from "@/app/app/_/routing";
import { RuleListTab } from "@/app/app/_/views/RulesView/RuleListTab";
import { State } from "@/state";

export function RulesView() {
  const routeState = useAppRouteState();
  const activeTab = State((state) => state.activeTab);
  const selectedRuleId = State(
    (state) =>
      (state.activeTabNodeIds as any)?.rules?.[activeTab] ?? routeState.ruleId,
  );

  if (selectedRuleId) {
    return <RuleDetailPage />;
  }

  return <RuleListTab />;
}
